import { atom } from 'recoil';
import { Family } from 'types/family';

const familyAccount = atom<Family[] | null>({
	key: 'familyAccount',
	default: null,
});

export const familyStore = {
	familyAccount,
};
